// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1t1Zi","dragIcon":"Choice_dragIcon__1cIjG","left":"Choice_left__3U_h3","input":"Choice_input__3wrPX"};